import { ConfirmationAlertData } from "../classes/shared/confirmation-alert-data.class";
import { DynamicForm } from "../classes/dynamic-form/dynamic-form.class";
import { IndPageTitleViewDataModel } from "./indPageTitleDataModel";
import { IonNav } from '@ionic/angular';

export enum DynamicFormType {
    CONFIGUREDFORM = 'configured-form',
    DEFAULTFORM = 'default-form',
}

export interface DynamicFormComponentModel {
    formMetadata:DynamicForm;
    formEntityObject:any;
    mainEntityObjectId:any;
    title:string;
    LookupEntitySetName:string;
    showSearchBar?:boolean;
    enableSubgridDataEditing?:boolean;
    showLeftHeaderButton?:boolean;
    leftHeaderBtnImgSrc?: string;
    leftHeaderBtnIcon?:string;
    leftHeaderBtnText?:string;
    isEditFormWithLinkedData?:boolean;
    isUpdatedLinkedEnityFormData?: boolean;
    linkedEntityExistingDataId?: string;
    linkedEntityExistingDataAddressId?: string;
    linkedEntityAddedNewDataId?: string;
    linkedEntityValue?: any[];
    targetControlAttribName?: string;
    showClearButton?: boolean;
    showRightHeaderButton?:boolean;
    rightHeaderImgSrc?: string;
    rightHeaderBtnText?:string;
    rightHeaderImgSrcArray?: any[];
    rightHeaderBtnTextArray?: any[];
    rightHeaderBtnIdsArray?: any[];
    dynamicFormType?:DynamicFormType;
    linkedEntityParentData?: any;
    customFields?: any;
    confirmationCheckRequired?:boolean;
    confirmationAlertData?:ConfirmationAlertData;
    navOptions?: any;
    eventsHandler?:(data:any, eventTarget:string, refData?:DynamicFormComponentModel)=>void;
    /** Optional footer view key (e.g. 'MedicalInquiryNew') to show footer toolbar with that view's buttons */
    footerView?: string;
    /**
     * When true, this form renders no footer toolbar of its own, because the host page already renders
     * one - an activity embedded in Meeting Presentation. Every other embedded activity hides its own
     * footer the same way (see footerService.fabNotRequestedFromPresentation); the shared form has no
     * activity type to key off, so the host sets this instead. Only safe when the form's actions are
     * also reachable from its header via rightHeaderBtnIdsArray.
     */
    hideFooterToolbar?: boolean;
    /**
     * When true, a parent component (e.g. MedicalInquiryNewComponent via MedicalInquiryFooterRestoreService)
     * is already responsible for restoring the footer on view re-entry. DynamicFormComponent will skip
     * setting up its own IntersectionObserver to avoid conflicting with the parent's restoration logic.
     */
    footerViewManagedByParent?: boolean;
    /**
     * When true, address lookup uses local DB (PouchDB) filtered by selected contact and shows a dropdown list.
     * When false or unset, existing lookup/search/API behaviour is used.
     */
    loadAddressFromLocal?: boolean;
    /**
     * For MedicalInquiryNew: when true, the footer Submit button is unlocked (visible/enabled when form is valid).
     * Set by parent after first save creates the medical inquiry record.
     */
    footerSubmitUnlocked?: boolean;
    /**
     * Optional IonNav reference for navigation within a modal.
     * When provided, lookup field push navigations (contact, account) will use this IonNav
     * instead of the default app nav, keeping them inside the modal.
     */
    modalNavCtrl?: IonNav;
}
